module.exports = __webpack_public_path__ + "static/android_2_EN-94f7b6f4699168f0e1d20ce1a492d841.jpg";